var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maps-circle-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3836 10.7271C11.2572 10.8489 11.0881 10.917 10.9122 10.917C10.7362 10.917 10.5672 10.8489 10.4407 10.7271C9.28249 9.60479 7.73029 8.35109 8.48726 6.53089C8.89654 5.54674 9.87896 4.91699 10.9122 4.91699C11.9454 4.91699 12.9278 5.54674 13.3371 6.53089C14.0931 8.34877 12.5447 9.60862 11.3836 10.7271Z",
    stroke: "#6C757D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9121 7.54199H10.9181",
    stroke: "#6C757D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5371 9.41699C16.5371 13.5591 13.1792 16.917 9.03711 16.917C4.89497 16.917 1.53711 13.5591 1.53711 9.41699C1.53711 5.27485 4.89497 1.91699 9.03711 1.91699C13.1792 1.91699 16.5371 5.27485 16.5371 9.41699Z",
    stroke: "#6C757D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.78711 11.667L3.78711 14.667M11.2871 16.167L2.28711 7.16699",
    stroke: "#6C757D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map_icon.f210cab57ca6c31a2dfbf33daa17cd30.svg";
export { ForwardRef as ReactComponent };